import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";

export const CommonListModalWrapper = styled.div`
  .list-item-container {
    display: flex;
    justify-content: space-between;
    padding: 6px 12px 0px 16px;
    align-items: center;

    .item-title {
      cursor: pointer;
      color: ${COLORS.primary_light_blue};
    }
  }
`;
